import { ROUTE } from "../../routes";
export const contactUsAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const tryAgainAction = async (action, _datastore, { navigateToBase }) => {
    await navigateToBase(ROUTE.KYC_DOCUMENTS_DIGIO_BASE);
};
export const tryAgainBank = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.BANK_ACCOUNT_VERIFICATION);
};
export const backAction = async (action, _datastore, { navigateWithClear }) => {
    await navigateWithClear(ROUTE.KYC_STEPPER);
};
export const continueAction = async (action, _datastore, { navigate }) => {
    navigate(ROUTE.SUPPORTING_DOCUMENT);
};
